import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import { CartProvider } from "@/lib/cart";
import { AuthProvider } from "@/lib/auth";
import { setLenis } from "@/lib/scroll";
import AgeGate from "@/components/AgeGate";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Titles from "@/components/Titles";
import ReleaseCountdown from "@/components/ReleaseCountdown";
import CharacterDossiers from "@/components/CharacterDossiers";
import MarySpotlight from "@/components/MarySpotlight";
import ShopTeaser from "@/components/ShopTeaser";
import CartDrawer from "@/components/CartDrawer";
import Gallery from "@/components/Gallery";
import Testimonial from "@/components/Testimonial";
import Forms from "@/components/Forms";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollTopButton from "@/components/ScrollTopButton";
import Submissions from "@/pages/Submissions";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import ShopPage from "@/pages/ShopPage";
import Account from "@/pages/Account";
import WishlistShare from "@/pages/WishlistShare";
import ReferralLanding from "@/pages/ReferralLanding";
import ResetPassword from "@/pages/ResetPassword";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Admin from "@/pages/Admin";

function Home({ unlocked }) {
  return (
    <>
      <Navbar verified={unlocked} />
      <main>
        <Hero unlocked={unlocked} />
        <div className="overflow-x-clip">
          <Marquee />
        </div>
        <Manifesto />
        <Titles />
        <ReleaseCountdown />
        <CharacterDossiers />
        <MarySpotlight />
        <ShopTeaser />
        <Gallery />
        <Testimonial />
        <Forms />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  const [verified, setVerified] = useState(
    () => localStorage.getItem("atrocity-age-verified") === "yes"
  );

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08 });
    setLenis(lenis);
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = verified ? "" : "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [verified]);

  return (
    <CartProvider>
      <AuthProvider>
      <div className="App bg-void text-paper min-h-screen">
        <AnimatePresence>
          {!verified && <AgeGate onVerify={() => setVerified(true)} />}
        </AnimatePresence>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home unlocked={verified} />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/account" element={<Account />} />
            <Route path="/wishlist/:userId" element={<WishlistShare />} />
            <Route path="/r/:code" element={<ReferralLanding />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/submissions" element={<Submissions />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </BrowserRouter>
        <CartDrawer />
        <CookieBanner />
        <ScrollTopButton />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#120A0E",
              border: "2px solid #F60404",
              color: "#EAE4DC",
              fontFamily: "'Special Elite', monospace",
              borderRadius: "2px",
            },
          }}
        />
      </div>
      </AuthProvider>
    </CartProvider>
  );
}
